// extracted by mini-css-extract-plugin
module.exports = {"menu-view__title":"n_5 my-2 p-2","menu-view__tile-row":"n_6 d-flex"};